import { Link } from "react-router-dom";
import { BadgeCheck, Star, MapPin } from "lucide-react";
import { mediaUrl } from "../lib/api";
import { useCurrency } from "../context/CurrencyContext";

export default function ProductCard({ product }) {
  const { fmtRange } = useCurrency();
  const img = mediaUrl(product.thumb || product.image);
  return (
    <Link
      data-testid={`product-card-${product.id}`}
      to={`/product/${product.id}`}
      className="group block overflow-hidden rounded-2xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-teal-500/30"
    >
      <div className="aspect-square overflow-hidden bg-teal-50">
        {img ? (
          <img
            src={img}
            alt={product.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-teal-300 text-sm">No image</div>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading font-semibold text-slate-900 leading-snug line-clamp-2 min-h-[2.6rem]">
          {product.title}
        </h3>
        <div className="mt-2 flex items-baseline gap-1">
          <span data-testid={`product-price-${product.id}`} className="text-lg font-bold text-teal-700">
            {fmtRange(product)}
          </span>
          {product.unit && <span className="text-xs text-slate-500">/ {product.unit}</span>}
        </div>
        <div className="mt-1 text-xs text-slate-500">MOQ: {product.moq} {product.unit || "pcs"}</div>
        <div className="mt-3 flex items-center gap-1.5 text-xs text-slate-600">
          {product.verified && <BadgeCheck className="h-3.5 w-3.5 text-teal-600" />}
          <span className="truncate">{product.supplier_name}</span>
        </div>
        <div className="mt-1 flex items-center justify-between text-xs text-slate-500">
          <span className="flex items-center gap-1">
            <MapPin className="h-3 w-3" /> {product.country}
          </span>
          {product.rating > 0 && (
            <span className="flex items-center gap-1">
              <Star className="h-3 w-3 fill-amber-400 text-amber-400" /> {product.rating}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
